import * as ActionTypes from '../ActionTypes';

const initialState = {
    businessunitData: [],
    isLoading: false,
};

const BusinessUnitReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.BUSINESSUNIT_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                businessunitData: "",
            };
        case ActionTypes.BUSINESSUNIT_GET_SUCCESS:
            return {
                ...state,
                success_message: action.payload.message,
                error: action.payload.has_error,
                isLoading: false,
                businessunitData: action.payload?.data?.data
            };
        case ActionTypes.BUSINESSUNIT_ADD_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.BUSINESSUNIT_ADD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                businessunitData: action.payload?.data?.data
            };
        case ActionTypes.BUSINESSUNIT_ADD_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.BUSINESSUNIT_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.BUSINESSUNIT_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                businessunitData: action.payload?.data?.data
            };
        case ActionTypes.BUSINESSUNIT_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.BUSINESSUNIT_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.BUSINESSUNIT_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                businessunitData: action.payload?.data?.data
            };
        case ActionTypes.BUSINESSUNIT_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        default:
            return state;
    }
}

export default BusinessUnitReducer;